import React from 'react';

const SkeletonLoader = () => {
  return (
    <div className="space-y-4 md:space-y-6">
      {[1, 2, 3]?.map((item) => (
        <div key={item} className="bg-card rounded-lg shadow-gaming-md overflow-hidden">
          <div className="aspect-[16/9] bg-muted" />
          <div className="p-4 md:p-5 space-y-3">
            <div className="h-5 bg-muted rounded w-3/4" />
            <div className="h-4 bg-muted rounded w-1/2" />
            <div className="flex items-center justify-between">
              <div className="h-3 bg-muted rounded w-24" />
              <div className="h-3 bg-muted rounded w-16" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;